<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item">
        <b-col>
          <router-link class="btn" :to="{name: 'EXCMRegionUpdate', params: { id: item['@id'] }}">
            <span v-if="!mobileView">{{ $t('buttons.edit') }}</span>
            <i v-else class="far fa-edit"></i>
          </router-link>
          <button class="btn btn-warning" @click="archiveItem(item)">{{ $t('buttons.archive') }}</button>
          <router-link :to="{ name: 'EXCMRegionList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row v-if="item">
                <b-col cols="12">
                  <p><b>{{$t('views.excmregion.show.title')}}:</b> {{ item.name }}</p>
                </b-col>
                <b-col cols="12" v-for="(regionUserDataItem, regionUserDataIndex) in item.regionUserData" v-bind:key="'regionUserDataItem-' + regionUserDataIndex">
                  <b-row>
                    <b-col sm="12" lg="1">
                      <h5 class="text-center">#{{ regionUserDataIndex + 1 }}</h5>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <p class="mb-0 mt-1" v-bind:class="{ 'text-center': mobileView }">{{ regionUserDataItem.userData.name }} {{ regionUserDataItem.userData.surname }}</p>
                      <p class="mb-0 mt-1" v-bind:class="{ 'text-center': mobileView }">{{ regionUserDataItem.userData.contactEmail || regionUserDataItem.userData.userEmail}}</p>
                    </b-col>
                    <b-col sm="12" lg="3">
                      <div v-bind:class="{ 'float-right': !mobileView }">
                        <b-btn class="btn btn-danger mt-2" size="sm" @click="removeRegionUserDataItem(regionUserDataItem)">
                          <span v-if="!mobileView">{{ $t('buttons.delete') }}</span>
                          <i v-else class="far fa-trash-alt"></i>
                        </b-btn>
                      </div>
                    </b-col>
                    <b-col cols="12" v-if="item.regionUserData.length > (regionUserDataIndex + 1)">
                      <hr class="mt-1 mb-1">
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <b-btn variant="success" @click="createRegionUserDataItem()">{{ $t('views.excmregion.show.addUserData') }}</b-btn>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <EXCMRegionUserDataCreateModal></EXCMRegionUserDataCreateModal>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import getId from '@/utils/getIdFromLink'
import EXCMRegionUserDataCreateModal from '../excmregionuserdata/components/EXCMRegionUserDataCreateModal'

export default {
  computed: {
    ...mapGetters({
      deleteError: 'excmregion/del/error',
      error: 'excmregion/show/error',
      isLoading: 'excmregion/show/isLoading',
      item: 'excmregion/show/retrieved'
    }),
    mobileView () {
      return this.$store.state.mobileView
    },
    excmRegionUserDataCreated () {
      return this.$store.state.modals.excmregionuserdata.create.created
    }
  },

  watch: {
    excmRegionUserDataCreated: function (val) {
      if (val === 1) {
        this.$store.state.modals.excmregionuserdata.create.created = 0
        this.retrieve(decodeURIComponent(this.$route.params.id))
      }
    }
  },

  components: {
    Loader,
    EXCMRegionUserDataCreateModal
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      delRegion: 'excmregionuserdata/del/del',
      del: 'excmregion/del/del',
      reset: 'excmregion/show/reset',
      retrieve: 'excmregion/show/retrieve'
    }),

    createRegionUserDataItem () {
      this.$store.state.modals.excmregionuserdata.create.show = 1
      this.$store.state.modals.excmregionuserdata.create.region = this.item
    },

    editRegionUserDataItem (item) {
      // this.$store.state.modals.excmregionuserdata.create.show = 1
      // this.$store.state.modals.excmregionuserdata.create.region = item
    },

    removeRegionUserDataItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.delRegion(item).then(() => this.retrieve(decodeURIComponent(this.$route.params.id)))
        }
      })
    },

    redirectAfterDelete () {
      if (this.deleteError === '') {
        this.$router.push({ name: 'EXCMRegionList' })
      } else {
        this.$store.state.excmsla.del.error = ''
      }
    },

    archiveItem (item) {
      this.$http
        .put('api/e_x_c_m_regions/' + this.getIdLink(this.item['@id']), {
          state: 0
        })
        .then(response => {
          this.$router.push({ name: 'EXCMRegionList' })
          this.$Swal({ // show notification with success
            type: 'success',
            title: this.$t('notifications.update.updatedTitle'),
            showConfirmButton: false,
            timer: 2500
          })
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.del(item).then(() => this.redirectAfterDelete())
        }
      })
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
